// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    name: {
        id: 'device-list-item.name',
        defaultMessage: 'Device name'
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/device-list/item/intl.js